import { Reveal } from "@/lib/motion";
import { IMAGES } from "@/lib/images";
import { MapPin, Clock, HeartPulse, Dumbbell } from "lucide-react";

const facts = [
  { icon: Dumbbell, label: "Treningi", value: "1:1, w pełni personalne" },
  { icon: HeartPulse, label: "Dla kogo", value: "Kobiety 30+" },
  { icon: Clock, label: "Pierwszy krok", value: "Umów konsultację" },
];

export const Method = () => (
  <section id="lokalizacja" className="relative py-16 md:py-24 bg-[#0F0E0E]">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
      <Reveal>
        <div className="relative overflow-hidden clip-frame">
          <img
            src={IMAGES.gym}
            alt="Zdrofit Stegny"
            className="w-full aspect-[4/5] object-cover grayscale hover:grayscale-0 transition-all duration-700"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0F0E0E]/60 to-transparent" />
        </div>
      </Reveal>

      <div>
        <Reveal>
          <span className="text-xs uppercase tracking-[0.25em] text-[#FF6B6B]">Lokalizacja</span>
          <h2 className="font-display font-light text-4xl md:text-6xl mt-6 leading-[0.95]">
            Trenujemy w Zdrofit Warszawa Stegny
          </h2>
          <div className="flex items-start gap-3 mt-8 text-lg text-[#F5F2F0]">
            <MapPin className="w-6 h-6 text-[#FF6B6B] mt-1 shrink-0" />
            <span>
              ul. Mangalia 4, Warszawa
              <span className="block text-muted text-base mt-1">Mokotów / Stegny</span>
            </span>
          </div>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-3 gap-px border border-[#2A2626]">
          {facts.map((f, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="p-7 border-r border-b border-[#2A2626] h-full">
                <f.icon className="w-6 h-6 text-[#FF6B6B]" />
                <p className="text-xs uppercase tracking-[0.2em] text-muted mt-5">{f.label}</p>
                <p className="text-[#F5F2F0] mt-1 font-medium">{f.value}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-10 overflow-hidden border border-[#2A2626]">
            <iframe
              title="Mapa Zdrofit Stegny"
              src="https://www.google.com/maps?q=ul.%20Mangalia%204%20Warszawa&output=embed"
              className="w-full h-64 grayscale invert-[0.9] contrast-[1.1]"
              loading="lazy"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
